import React from 'react';
import { WIZARD_STEPS, type WizardStep } from './types';
import type { WizardStepperState } from './wizardState';

const STEP_MARKERS = ['①', '②', '③', '④'] as const;

type Props = WizardStepperState;

export default function WizardProgress({ activeStep, completedSteps }: Props) {
  return (
    <nav className="wizard-progress" aria-label="Setup progress">
      <ol className="wizard-progress-track">
        {WIZARD_STEPS.map((s, index) => {
          const done = completedSteps.has(s.id);
          const active = activeStep === s.id && !done;
          return (
            <li
              key={s.id}
              className={`wizard-progress-step${active ? ' wizard-progress-step--active' : ''}${
                done ? ' wizard-progress-step--done' : ''
              }`}
              aria-current={active ? 'step' : undefined}
            >
              <span className="wizard-progress-marker" aria-hidden>
                {done ? '✓' : STEP_MARKERS[index]}
              </span>
              <span className="wizard-progress-label">{s.label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
